import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/niraj-portfolio'
      className='link footer__link'
    >
      Created By Niraj Kumar Mahto
    </a>
  </footer>
)

export default Footer
